import React from "react";
import { Link } from "react-router-dom";
import styles from "./NotFound.module.css";

const NotFound: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2 className={styles.subtitle}>
          Sorry, we can't find what you're looking for
        </h2>
        <p className={styles.description}>
          The page you're looking for doesn't exist or may have been moved.
        </p>
        <div className={styles.actions}>
          <Link to="/" className={styles.homeButton}>
            Go to Home
          </Link>
          <Link to="/contact" className={styles.contactButton}>
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
